import { SetupIdentificationComponent } from '../components/setup-identification/setup-identification.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatMenuModule } from '@angular/material/menu';
import { NgSelectModule } from '@ng-select/ng-select';
import { SharedModule } from 'src/app/shared/shared.module';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { DragDropModule } from '@angular/cdk/drag-drop';

import { SetupRoutingModule } from './setups-routing.module';
import { ListSetupsComponent } from '../components/list-setups/list-setups.component';
import { AddNewSetupComponent } from '../components/add-new-setup/add-new-setup.component';

import { SetupsComponent } from './setups.component';
import { ModuleSettingModalComponent } from '../components/add-new-setup/components/module-setting-modal.component';

@NgModule({
  imports: [
    CommonModule,
    SetupIdentificationComponent,
    NgSelectModule,
    FormsModule,
    ReactiveFormsModule,
    MatMenuModule,
    SharedModule,
    MatIconModule,
    MatTooltipModule,
    SetupRoutingModule,
    DragDropModule
  ],
  declarations: [SetupsComponent, ListSetupsComponent, AddNewSetupComponent, ModuleSettingModalComponent]
})
export class SetupModule {}
